import moment from 'moment';
import {useSelector} from 'react-redux';
import {logForCrashlytics} from 'src/Utils/fireUtils';
import {getReduxState} from './helpers';
// import { Alert } from 'react-native';

export const useExplorerPass = () => {
  logForCrashlytics('getExplorerPassHook fired in backpackFunctions');
  const pass = useSelector((state) => state.user?.info?.pass);
  let explorerPass = false;

  // console.log('get explorer fired');
  if (pass && pass.expiresDate) {
    console.log('the user has a pass that may or not be valid', {pass});
    const hasValidExplorerPass = moment(pass.expiresDate).isAfter(moment());
    if (hasValidExplorerPass) {
      explorerPass = pass;
    }
  }
  // console.log('get explorer done', {calledFrom, explorerPass, pass});
  return explorerPass;
};

export const getExplorerPass = () => {
  logForCrashlytics('getExplorerPassHook fired in backpackFunctions');
  const pass = getReduxState(['user', 'info', 'pass']);
  let explorerPass = false;

  // console.log('get explorer fired');
  if (pass && pass.expiresDate) {
    console.log('the user has a pass that may or not be valid', {pass});
    const hasValidExplorerPass = moment(pass.expiresDate).isAfter(moment());
    if (hasValidExplorerPass) {
      explorerPass = pass;
    }
  }
  // console.log('get explorer done', {calledFrom, explorerPass, pass});
  return explorerPass;
};
